let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("edTcR")).then(() => parcelRequire('1hTxv'));